import React, {useContext} from 'react';
import {withRouter} from 'react-router-dom';
import {useAppConfig} from "../../modules/local";
import {LoginContext} from "../LoginContext";

export const UnderConstruction = () => (
    <div style={{textAlign: 'center', paddingTop: '100px'}}>
        <h1>🚧 Under Construction 🚧</h1>
        <p>We're currently performing maintenance. Please check back later.</p>
    </div>
);

const EXCLUDED_PATHS = new Set([
    '/login',
    '/logout'
]);

const MaintenanceWrapper = ({children, location}) => {
    const {is_maintenance = false} = useAppConfig();
    const login = useContext(LoginContext);

    const isExcludedPath = EXCLUDED_PATHS.has(location?.pathname);
    const isAdminUser = !!login?.edit_system;

    const shouldShowMaintenance = Boolean(is_maintenance) && !isAdminUser && !isExcludedPath;

    if (shouldShowMaintenance) {
        return <UnderConstruction/>;
    }

    return children;
};

export default withRouter(MaintenanceWrapper);
